import React, { useState } from 'react';
import ModalContainer from '../ModalContainer/ModalContainer';
import { Box, Typography } from '@mui/material';
import CtaButton from '../CtaButton/CtaButton';

interface IProps {
  open: boolean;
  handleClose: () => void;
  title?: string;
  description?: string;
  onConfirm: () => void;
}

const ConfirmActionModal = ({
  open,
  handleClose,
  title,
  description,
  onConfirm,
}: IProps) => {
  const [loading, setLoading] = useState(false);

  const closeModalHandler = () => {
    if (loading) return;
    handleClose();
  };

  const onConfirmHandler = async () => {
    try {
      setLoading(true);
      await onConfirm();
      closeModalHandler();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalContainer open={open} handleClose={closeModalHandler}>
      <>
        <Typography variant="h5" textAlign="center" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="h6" textAlign="center" mt={4}>
          {description}
        </Typography>

        <Box display="flex" flexWrap="wrap" gap={4}>
          <CtaButton
            type="button"
            variant="text"
            sx={{ px: 6, mt: 6 }}
            disabled={loading}
            onClick={closeModalHandler}
          >
            Annulla
          </CtaButton>
          <CtaButton
            type="button"
            variant="contained"
            sx={{ px: 6, mt: 6 }}
            loading={loading}
            onClick={onConfirmHandler}
          >
            Conferma
          </CtaButton>
        </Box>
      </>
    </ModalContainer>
  );
};

export default ConfirmActionModal;
